const stripHtmlFallback = (value) => value.replace(/<[^>]*>/g, '')

export const getRichTextContent = (value) => {
  if (!value) return ''

  if (typeof document === 'undefined') {
    return stripHtmlFallback(value)
  }

  const tmp = document.createElement('div')

  tmp.innerHTML = value

  return (tmp.textContent || tmp.innerText || '')
}

export const getRichTextContentLength = (value) => {
  const content = getRichTextContent(value)

  return content.replace(/\n$/, '').length
}
